



import Vue from 'vue';
import {Component, Mixin} from 'vue-mixin-decorator';
import {IPieGenerator, IPiePath} from "@/types";

@Mixin
export default class SVGPieMixin extends Vue {

    getPaths(conf: IPieGenerator[], holeRadius: number = 0.5): IPiePath[] {
        const sum = conf.reduce((acc: number, a: IPieGenerator) => {
            return acc + a.amount
        }, 0)
        const c = Math.PI * 2 / sum
        let sumang = -90
        return conf.map((a) => {
            const angR = a.amount * c
            const angD = angR * (180 / Math.PI)
            const ret = {
                d: 'M 1 0 A 1 1 0 ' + (angR < Math.PI ? '0 ' : '1 ') + '1 ' + Math.cos(angR) + ' ' + Math.sin(angR) + ' L ' + Math.cos(angR) * holeRadius + ' ' + Math.sin(angR) * holeRadius + ' A ' + holeRadius + ' ' + holeRadius + ' 0 ' + (angR < Math.PI ? '0 ' : '1 ') + '0 ' + holeRadius + ' 0z',
                transform: `rotate(` + sumang + `)`,
                dataSettore: a.dataSettore
            };
            sumang += angD;
            return ret
        })
    }

    makePiePath(conf: IPieGenerator[], holeRadius: number = 0.5, innerRadius: number = 0.45) {
        if (holeRadius > 1 || holeRadius < 0) {
            holeRadius = 0.5
        }
        if (innerRadius > 1 || innerRadius < 0) {
            innerRadius = 0.45
        }
        const path = this.getPaths(conf, holeRadius)
        return `<svg class="cluster" viewBox="-1 -1 2 2">` + path.map((e, idx) => {
            return `<path transform="` + e.transform + `" data-settore="` + e.dataSettore + `" d="` + e.d + `"></path>`
        }).join('') + (!innerRadius ? '' : `<circle cx="0" cy="0" r="` + innerRadius + `" stroke="black" stroke-width="0" fill="white" />`) + `</svg>`;
    }
}
